import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-fa-range',
  templateUrl: './fa-range.component.html',
  styleUrls: [],
  standalone: false
})
export class FixedAssetsRangeComponent {
  @Input() from: any = null;
  @Input() to: any = null;

  @Output() readonly fromChange = new EventEmitter();
  @Output() readonly toChange = new EventEmitter();

  constructor() {}
}
